import { PageHeader, Stack, Tab, TabList } from "@justworkshr/milo-core";
import { ReactElement } from "react";
import {
  Navigate,
  Outlet,
  Route,
  Routes,
  useLocation,
  useNavigate,
} from "react-router-dom";
import ContractorsImage from "../../../international-solutions/images/contractors-banner.webp";
import styles from "../../InternationalSolutionsPage.module.css";
import ContractorPriceCard from "../../components/Cards/ContractorPriceCard";
import LookingForEorCard from "../../components/Cards/LookingForEorCard";
import { TABS } from "../../constants";
import { FAQ_PATH, OVERVIEW_PATH, RESOURCES_PATH } from "../../routes";
import { Faq } from "./Faq";
import Overview from "./Overview";
import Resources from "./Resources";

const Contractor = (): ReactElement => {
  const { container, column1, column2 } = styles;

  const navigate = useNavigate();
  const { pathname } = useLocation();

  const getSelectedTabIndex = (): number => {
    const index = TABS.findIndex((tab) => pathname.includes(tab.path));
    return index !== -1 ? index : 0;
  };

  const handleTabChange = (index: number) => {
    if (index === 0) {
      return navigate(`${OVERVIEW_PATH}`);
    } else if (index === 1) {
      return navigate(`${FAQ_PATH}`);
    } else if (index === 2) {
      return navigate(`${RESOURCES_PATH}`);
    } else {
      return navigate(`${OVERVIEW_PATH}`);
    }
  };

  return (
    <>
      <PageHeader
        title="Build your team, beyond borders"
        children={
          <span>
            Pay people in top talent markets around the world, all from the same
            platform you already know and trust.
          </span>
        }
      />
      <div className={container}>
        <div className={column1}>
          <img src={ContractorsImage} alt="" />
          <TabList
            orientation="horizontal"
            selected={getSelectedTabIndex()}
            onChange={handleTabChange}
          >
            {TABS.map((tab) => (
              <Tab key={tab.path}>{tab.name}</Tab>
            ))}
          </TabList>

          <Outlet />

          <Routes>
            <Route path={`${OVERVIEW_PATH}`} element={<Overview />} />
            <Route path={`${FAQ_PATH}`} element={<Faq />} />
            <Route path={`${RESOURCES_PATH}`} element={<Resources />} />
            <Route
              path="*"
              element={<Navigate to={`${OVERVIEW_PATH}`} replace />}
            />
          </Routes>
        </div>

        <div className={`${column2}`}>
          <Stack spacing="xl">
            <ContractorPriceCard />
            <LookingForEorCard />
          </Stack>
        </div>
      </div>
    </>
  );
};

export default Contractor;
